import { BRAND_ACCENT_PALETTE } from '../constants';
import * as styled from '../styles/branding-customizer';

type Props = {
  themePreset: LandingV2.ThemePreset;
  accentColor: string | null;
  avatarBorderColor: string | null;
  onThemeChange: (preset: LandingV2.ThemePreset) => void;
  onAccentChange: (color: string | null) => void;
  onBorderChange: (color: string | null) => void;
};

export const BrandingCustomizer = ({
  themePreset,
  accentColor,
  avatarBorderColor,
  onThemeChange,
  onAccentChange,
  onBorderChange,
}: Props) => (
  <styled.Panel>
    <styled.IntroGroup>
      <styled.Kicker>Try it live</styled.Kicker>
      <styled.Title>Your page, your brand</styled.Title>
    </styled.IntroGroup>

    <styled.Caption>
      This is the real branding feature every creator page has — the same colors,
      the same options. Change something and watch the preview update.
    </styled.Caption>

    <styled.FieldGroup>
      <styled.SectionLabel>Theme</styled.SectionLabel>
      <styled.SegmentRow>
        <styled.SegmentItem type="button" $active={themePreset === 'personal'} onClick={() => onThemeChange('personal')}>
          Personal
        </styled.SegmentItem>
        <styled.SegmentItem type="button" $active={themePreset === 'business'} onClick={() => onThemeChange('business')}>
          Business
        </styled.SegmentItem>
      </styled.SegmentRow>
    </styled.FieldGroup>

    <styled.FieldGroup>
      <styled.SectionLabel>Accent color</styled.SectionLabel>
      <styled.SwatchRow>
        {BRAND_ACCENT_PALETTE.map((color) => (
          <styled.Swatch
            key={`accent-${color}`}
            type="button"
            $color={color}
            $selected={accentColor === color}
            onClick={() => onAccentChange(color === accentColor ? null : color)}
            aria-label={`Accent color ${color}`}
          >
            {accentColor === color ? '✓' : ''}
          </styled.Swatch>
        ))}
      </styled.SwatchRow>
    </styled.FieldGroup>

    <styled.FieldGroup>
      <styled.SectionLabel>Avatar border</styled.SectionLabel>
      <styled.SwatchRow>
        <styled.SwatchEmpty
          type="button"
          $selected={avatarBorderColor === null}
          onClick={() => onBorderChange(null)}
        >
          None
        </styled.SwatchEmpty>
        {BRAND_ACCENT_PALETTE.map((color) => (
          <styled.Swatch
            key={`border-${color}`}
            type="button"
            $color={color}
            $selected={avatarBorderColor === color}
            onClick={() => onBorderChange(color === avatarBorderColor ? null : color)}
            aria-label={`Avatar border ${color}`}
          >
            {avatarBorderColor === color ? '✓' : ''}
          </styled.Swatch>
        ))}
      </styled.SwatchRow>
    </styled.FieldGroup>
  </styled.Panel>
);
